// extracted by mini-css-extract-plugin
module.exports = {"root":"Modal_root__3fo4-","modal":"Modal_modal__3DAc5","veil":"Modal_veil__2qCVJ","veilContained":"Modal_veilContained__22wKp"};